export default __webpack_public_path__ + "static/media/guesty_lite_step11.9d5e02fb.png";